export const api = {
  getBannerList: "/yaji_web/Home/getBannerList",
  getCatsList: "/yaji_web/Home/getCatsList",
  getDevelopList: "/yaji_web/Home/getDevelopList",
  getVideoList: "/yaji_web/Home/getVideoList",
  getNewsList: "/yaji_web/Home/getNewsList",
  getNewsInfo: "/yaji_web/Home/getNewsInfo",
  getReportList: "/yaji_web/Home/getQualityReportList",
  getProductList: "/yaji_web/Home/getProductList",
  getRecruitList: "/yaji_web/Home/getRecruitList",
  checkAntiFake: "/yaji_web/Home/checkAntiFake"
}
